import type { Types } from '../model';

export const imageApi = () => {
  const { $jsonApi } = useNuxtApp();

  const create = async (image: Types.IImageCreate) => {
    return $jsonApi.prefix('api').all('image').post<Types.IImage>(image);
  };

  const update = async (image: Types.IImageUpdate) => {
    return $jsonApi.prefix('api').one('image', image.id).patch(image);
  };

  const remove = async (id: string) => {
    return $jsonApi.prefix('api').one('image', id).destroy();
  };

  return { create, update, remove };
};
